<script>
  import Icon from '$shared/icons/Icon.svelte';

  export let editable = false;
</script>

<div class="absolute z-10 sm:-left-3 top-0 h-full flex items-start">
  {#if editable}
    <div class="w-7 h-7 bg-white md:bg-transparent shadow-md md:shadow-none rounded border-right-px place-content-center handle cursor-grab">
      <Icon icon="GripVertical" size="medium" />
    </div>
  {/if}
</div>